
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.193 22a2.044 2.044 0 01-1.438-.586.386.386 0 01-.042-.045l-3.757-4.325 2.489-2.515 4.207 3.92a2.1 2.1 0 010 2.944 2.039 2.039 0 01-1.459.607zM4.777 22a2.042 2.042 0 01-1.46-.607 2.1 2.1 0 010-2.944L13.6 8.063a4.658 4.658 0 01-.229-1.438A4.611 4.611 0 0117.953 2a4.552 4.552 0 011.423.23L17.6 4.024a2.1 2.1 0 000 2.944 2.057 2.057 0 002.919 0l1.785-1.8a4.661 4.661 0 01.236 1.458 4.61 4.61 0 01-4.585 4.625 4.541 4.541 0 01-1.444-.237L6.237 21.393a2.04 2.04 0 01-1.46.607zM7.97 11.306L5.429 8.38a.774.774 0 00-.265-.189l-1.538-.537a.764.764 0 01-.3-.228L1.2 4.108a.781.781 0 01-.018-1.02l.675-.67A.635.635 0 012.33 2.2a.833.833 0 01.47.168l3.19 2.18a.766.766 0 01.251.293l.566 1.574a.779.779 0 00.188.244l2.9 2.7-1.924 1.946z","fill":"#222"}})])
          )
        }
      }
    